app.controller('CartCtrl', function($scope, $http, $q, $rootScope, $modal, $window) {
    /**
     * Flags to know when this controller is processing remote calls
     */
    $scope.is_processing = {
        // While updating the cart : add or remove
        update: 0,
        // While processing a payment
        pay: false,
        // While merging carts
        merge: false
    };
    $scope.add_update_process = function() {
        $scope.is_processing.update = ($scope.is_processing.update || 0) + 1;
    }
    $scope.remove_update_process = function() {
        $scope.is_processing.update = Math.max(0, ($scope.is_processing.update || 0) - 1);
    }

    $scope.alerts = [];
    $scope.closeAlert = function (index) {
        $scope.alerts.splice(index, 1);
    };

    // An array of cart id ready to be merge together
    $scope.carts_to_merge = [];
    $rootScope.user_tab       = "";
    $rootScope.user_zip       = "";
    $rootScope.user_company   = "";
    $rootScope.user_title     = "";
    $rootScope.user_firstname = "";
    $rootScope.user_lastname  = "";
    $rootScope.user_email     = "";
    $rootScope.user_age       = "";
    $rootScope.user_sex       = "";
    $rootScope.user_phone     = "";
    $rootScope.user_cellphone = "";
    $scope.refresh = function (callback) {
        $scope.add_update_process();
        var url   = '/cart/view_json';
        var query = [];
        if (PosConfig.context)
            query.push(PosConfig.context);
        if (PosConfig.session_id)
            query.push('PHPSESSID=' + PosConfig.session_id);
        var httpRequest = $http({
            method: 'GET',
            url: url + '?' + query.join('&')
        }).success(function(rsp, status) {
            rsp.amount = 0;
            if (rsp.items.length > 0) {
                for (var i = 0, l = rsp.items.length; i < l; i++) {
                    rsp.amount += parseFloat(rsp.items[i].amount);
                }
            }

            // Get the current ticket if any from the Screenings controller scope
            var screenings_ctrl = angular.element('#screeningsController');
            if (screenings_ctrl && screenings_ctrl.scope()) {
                $scope.ticket = screenings_ctrl.scope().ticket;
            }

            // Get the current ticket if any from the Articles controller scope
            var articles_ctrl = angular.element('#articlesController');
            if (articles_ctrl && articles_ctrl.scope()) {
                $scope.ticket = articles_ctrl.scope().ticket;
            }

            if ('session_id' in rsp)
                PosConfig.session_id = rsp.session_id;

            $scope.remove_update_process();

            $rootScope.cart = $scope.cart = rsp;
            callback && callback(null, rsp);
        }).error(function(rsp, status, headers, config) {
            $scope.remove_update_process();
            callback && callback(rsp);
        });
    }

    /**
     * Add one or multiple bookings to cart
     *
     * @param string screening_id: The screening _id
     * @param array bookings: An array like this
     *  [
     *      { "pricing_id": "pricing_id1", "nb": 2 },
     *      { "pricing_id": "pricing_id2", "nb": 1, "seat": "seat_label" }
     *  ]
     * @param boolean overbook: True to overbook, false otherwise
     * @param callable callback: A function called with an eventual error and the server response
     */
    $scope.add_bookings_to_cart = function(screening_id, bookings, overbook, callback) {
        $scope.add_update_process();
        var headers = {'Content-Type': 'application/x-www-form-urlencoded'};
        var data = {
            "id": screening_id,
            "format": "json",
            "pricing": {},
            "overbook": overbook ? 'true' : 'false'
        };
        _.each(bookings, function (booking) {
            if (!data.pricing[booking.pricing_id]) {
                data.pricing[booking.pricing_id] = [];
            }
            data.pricing[booking.pricing_id].push(booking);
        });

        var url   = '/screening/buy';
        var query = [];
        if (PosConfig.session_id)
            query.push('PHPSESSID=' + PosConfig.session_id);

        $http({'method': 'POST', 'url': url + '?' + query.join('&'), 'data': $.param(data), 'headers': headers}).
        success(function(rsp, status, headers, config) {
            $scope.remove_update_process();

            if ('session_id' in rsp)
                PosConfig.session_id = rsp.session_id;

            $scope.refresh();
            window.top.postMessage({"action": "tkt::cart:reload"}, '*')
            callback && callback(null, rsp);
        }).
        error(function(rsp, status, headers, config) {
            $scope.remove_update_process();
            callback && callback(rsp);
        });
    }

    /**
     * Create one or more bookings
     *
     * @param string screening_id: The screening _id
     * @param array bookings: An array like this
     *  [
     *      { "pricing_id": "pricing_id1", "nb": 2 },
     *      { "pricing_id": "pricing_id2", "nb": 1, "seat": "seat_label" }
     *  ]
     * @param boolean overbook: True to overbook, false otherwise
     * @param callable callback: A function called with an eventual error and the server response
     */
    $scope.create_bookings = function(screening_id, bookings, overbook, callback) {
        $scope.add_update_process();
        var headers = {'Content-Type': 'application/x-www-form-urlencoded'};
        var url     = '/screenings/book';
        var query   = [];
        if (PosConfig.session_id)
            query.push('PHPSESSID=' + PosConfig.session_id);
        var data = {
            "format": "json",
            "bookings": [],
            "overbook": overbook ? 'true' : 'false'
        };
        _.each(bookings, function (booking) {
            booking.screening_id = screening_id;
            data.bookings.push(booking);
        });

        $http({'method': 'POST', 'url': url + '?' + query.join('&'), 'data': $.param(data), 'headers': headers}).
        success(function(rsp, status, headers, config) {
            $scope.remove_update_process();

            if ('session_id' in rsp) {
                PosConfig.session_id = rsp.session_id;
                window.top.postMessage({"action": "tkt::set_session_id", "session_id": PosConfig.session_id}, '*')
            }

            $scope.refresh();
            callback && callback(null, rsp);
        }).
        error(function(rsp, status, headers, config) {
            $scope.remove_update_process();
            callback && callback(rsp);
        });
    }

    $scope.remove_from_cart = function (index, callback) {
        $scope.add_update_process();
        var url   = '/cart/remove/index/' + index;
        var query = [ 'format=json' ];
        if (PosConfig.context)
            query.push(PosConfig.context);
        if (PosConfig.session_id)
            query.push('PHPSESSID=' + PosConfig.session_id);

        var removed_item = null;
        if ($scope.cart && $scope.cart.items) {
            removed_item = $scope.cart.items.find(function (cart_item) {
                return cart_item.index === index;
            });
        }

        var httpRequest = $http({
            method: 'GET',
            url: url + '?' + query.join('&')
        }).success(function(rsp, status) {
            $scope.refresh();
            var ticket_ctrl = angular.element('#ticketController').scope();
            if (ticket_ctrl && ticket_ctrl.sync_ticket_articles_after_cart_removal) {
                ticket_ctrl.sync_ticket_articles_after_cart_removal(removed_item);
            }
            if (angular.element('#screeningsController').scope()) {
                dont_cache_next_time = true;
                angular.element('#screeningsController').scope().refresh(); // FIXME: Should be done somewhere else
            }
            if (angular.element('#articlesController').scope()) {
                angular.element('#articlesController').scope().refresh();
            }
            $scope.remove_update_process();
            callback && callback();
        }).error(function(rsp, status, headers, config) {
            $scope.remove_update_process();
            callback && callback(rsp);
        });
    }

    /**
     * Add bookings to cart or on tickets
     *
     * @param array bookings
     * @param callable callback: A function called with an eventual error and the server response
     */
    $scope.confirm_bookings = function(bookings, callback) {
        if (!bookings)
            return callback && callback(/*err*/null, []);

        $scope.add_update_process();

        var add_bookings_to_cart = function(bookings) {
            var deferred = $q.defer();

            var headers = {'Content-Type': 'application/x-www-form-urlencoded'};
            var data = {
                "format": "json",
                "bookings": bookings
            };
            var url   = '/carts/add_bookings';
            var query = [ ];
            if (PosConfig.context)
                query.push(PosConfig.context);
            if (PosConfig.session_id)
                query.push('PHPSESSID=' + PosConfig.session_id);
            url = url + '?' + query.join('&')

            $http({'method': 'POST', 'url': url, 'data': $.param(data), 'headers': headers}).
            success(function(rsp, status, headers, config) {
                deferred.resolve(bookings.map(function (b) {
                    b.added = true;
                    return b;
                }));
            }).
            error(function(rsp, status, headers, config) {
                deferred.resolve(bookings.map(function (b) {
                    b.added = false;
                    return b;
                }));
            });

            return deferred.promise;
        }

        var timeout = 0;

        var confirm_on_ticket = function(booking) {
           var deferred = $q.defer();
           setTimeout(function() {
                var headers = {'Content-Type': 'application/x-www-form-urlencoded'};
                var data    = { "booking": booking };
                var url = '/tickets/activate_booking';
                url += '/_id/' + booking.ticket_id;

                $http({
                    'method': 'POST',
                    'url': url,
                    'data': $.param(data),
                    'headers': headers
                }).success(function(rsp, status, headers, config) {
                    booking.confirmed = true;
                    deferred.resolve(booking);
                }).error(function(rsp, status, headers, config) {
                    booking.confirmed = false;
                    deferred.resolve(booking);
                });
            }, (++timeout) * 300);

            return deferred.promise;
        }

        var to_add_to_cart = bookings.filter(function (booking) {
            return !!booking.pricing_id;
        });
        var to_confirm_on_ticket = bookings.filter(function (booking) {
            return !!booking.ticket_id;
        });

        var tasks = [];
        if (to_add_to_cart.length) {
            tasks.push(add_bookings_to_cart(to_add_to_cart));
        }
        if (to_confirm_on_ticket.length) {
            tasks = tasks.concat(to_confirm_on_ticket.map(function (booking) {
                return confirm_on_ticket(booking);
            }));
        }

        $q.defer();
        // Execute all the promises
        $q.all(tasks)
        .then(
            function (responses) {
                var result = [];
                for (var i in responses) {
                    if ('added' in responses[i] || 'confirmed' in responses[i])
                        result.push(responses[i]);
                    else
                        result = result.concat(responses[i]);
                }
            window.top.postMessage({"action": "tkt::cart:reload"}, '*')
                return callback && callback(/*err*/null, result);
            },
            function (errors) {
                return callback && callback(errors);
            }
        );
    }

    /**
     * Release a booking
     *
     * @param booking
     * @param callable callback: A function called with an eventual error and the server response
     */
    $scope.release_booking = function (booking_id, callback) {
        $scope.add_update_process();
        var headers = {'Content-Type': 'application/x-www-form-urlencoded'};
        var data = {
            "format": "json",
        };
        $http({'method': 'POST', 'url': '/carts/release_booking/id/' + booking_id, 'data': $.param(data), 'headers': headers}).
        success(function(rsp, status, headers, config) {
            $scope.remove_update_process();
            $scope.refresh();
            callback && callback(null, rsp);
        }).
        error(function(rsp, status, headers, config) {
            $scope.remove_update_process();
            callback && callback(rsp);
        });
    }


    $scope.reset_cart = function() {
        $scope.add_update_process();
        var url   = '/cart/reset';
        var query = [ 'format=json' ];
        if (PosConfig.context)
            query.push(PosConfig.context);
        if (PosConfig.session_id)
            query.push('PHPSESSID=' + PosConfig.session_id);
        var removed_items = ($scope.cart && $scope.cart.items)
            ? $scope.cart.items.filter(function (item) { return item && !item.canceled; })
            : [];
        var httpRequest = $http({
            method: 'GET',
            url: url + '?' + query.join('&')
        }).success(function(rsp, status) {
            $scope.remove_update_process();
            $scope.refresh();
            var ticket_ctrl = angular.element('#ticketController').scope();
            if (ticket_ctrl && ticket_ctrl.sync_ticket_articles_after_cart_removal) {
                ticket_ctrl.sync_ticket_articles_after_cart_removal(removed_items);
            }
            if (angular.element('#screeningsController').scope())   // FIXME: Shoul be done somewhere else
                angular.element('#screeningsController').scope().refresh();
            if (angular.element('#articlesController').scope()) {
                angular.element('#articlesController').scope().refresh();
            }
        }).error(function(rsp, status, headers, config) {
            $scope.remove_update_process();
        });
    }

    var cart_scope = $scope;

    $scope.is_cart_empty = function() {
        return !$scope.cart || $scope.cart.items.length <= 0
    }

    // Expose public methods
    this.add_bookings_to_cart = function(screening_id, bookings, overbook, callback) {
        return $scope.add_bookings_to_cart(screening_id, bookings, overbook, callback);
    };
    this.create_bookings = function(screening_id, bookings, overbook, callback) {
        return $scope.create_bookings(screening_id, bookings, overbook, callback);
    };
    this.remove_from_cart = function (index, callback) {
        return $scope.remove_from_cart(index, callback);
    };
    this.confirm_bookings = function(bookings, callback) {
        return $scope.confirm_bookings(bookings, callback);
    };
    this.release_booking = function(booking_id, callback) {
        return $scope.release_booking(booking_id, callback);
    };
    this.refresh = function(callback) {
        return $scope.refresh(callback);
    };

    this.redirect_to_cart_view = function () {
        var url   = '/cart/view';
        var query = [];
        if (PosConfig.session_id)
            query.push('PHPSESSID=' + PosConfig.session_id);
        $window.location.href = url + '?' + query.join('&');
    };

    return this;
});
